import { useFeedback } from "@opendash/core";
import { useTranslation } from "@opendash/i18n";
import { Source, Tenant } from "@opendash/plugin-parse/dist/types-generated";
import Parse from "parse";
import { useState } from "react";
import { Item } from "../../../js/parsegenerated";
import FormData from "../types/FormData";

export default () => {
  const t = useTranslation();
  const [saving, setSaving] = useState(false);
  const { notification } = useFeedback();

  async function saveItem(
    values: FormData,
    onSaveSuccess?: Function,
    item?: Item
  ) {
    setSaving(true);
    try {
      if (item) await updateItem(values, item);
      else await saveNewItem(values);

      if (onSaveSuccess) onSaveSuccess();
    } catch (e) {
      console.error(e);
      notification.open({
        message: t("maintenance:global.notifications.save.error.title"),
        description: t("maintenance:items.create.save.error.description"),
        type: "error",
      });
    }
    setSaving(false);
  }

  async function saveNewItem(values: FormData) {
    const tenant: Tenant = await Parse.User.current().get("tenant").fetch();
    const sources = await new Parse.Query(Source)
      .containedIn("objectId", values.source)
      .find();

    // Create a new item
    const createdItem = new Item({
      name: values.title,
      description: values.description,
      category: values.category,
      price: values.price + "",
      stock: values.stock,
      stockUnit: values.stockUnit,
      stockAlarmAt: values.stockAlarmAt,
      orderNumber: values.orderNumber,
      internalNumber: values.internalNumber,
      storageLocation: values.storageLocation,
      supplier: values.supplier,
      tenant,
    });
    createdItem.sources.add(sources);

    await createdItem.save();
  }

  async function updateItem(values: FormData, item: Item) {
    item.set({
      name: values.title,
      description: values.description,
      category: values.category,
      price: values.price + "",
      stock: values.stock,
      stockUnit: values.stockUnit,
      stockAlarmAt: values.stockAlarmAt,
      orderNumber: values.orderNumber,
      internalNumber: values.internalNumber,
      storageLocation: values.storageLocation,
      supplier: values.supplier,
    });

    // update sources
    const sources = await new Parse.Query(Source)
      .containedIn("objectId", values.source)
      .find();
    const currentItemSources = await item.sources.query().find();
    item.sources.remove(currentItemSources);
    item.sources.add(sources);

    await item.save();
  }

  return { saveItem, saving };
};
